import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { sendEvent } from 'src/lib/google-analytics';
import { Construction } from 'src/models/resort/Construction';
import { UserColor } from 'src/models/resort/UserColor';
import { ResortConstructionGridItem } from './ResortConstructionGridItem';

interface ResortConstructionGridItemsProps {
  items: Construction[];
  userColor: UserColor;
  onItemClick: (item: Construction) => void;
}

export const ResortConstructionGridItems = ({
  items,
  userColor,
  onItemClick
}: ResortConstructionGridItemsProps) => {
  const { t } = useTranslation('resort');

  if (items.length === 0) {
    sendEvent('resort_empty_construction', 'display');
    return (
      <p
        className={css`
          padding: 24px 16px;
          text-align: center;
          color: #4d3906;
          font-size: 16px;
        `}
      >
        {t('resort_empty')}
      </p>
    );
  }

  return (
    <ul
      className={css`
        display: flex;
        flex-wrap: wrap;

        .const-grid-item {
          width: 50%;
          margin: 20px 0 12px;
        }
        .const-grid-item:nth-child(2n + 1) {
          padding-right: 6px;
        }
        .const-grid-item:nth-child(2n) {
          padding-left: 6px;
        }
      `}
    >
      {items.map((item, index) => (
        <li key={index} className="const-grid-item">
          <ResortConstructionGridItem
            construction={item}
            userColor={userColor}
            onClick={onItemClick}
          />
        </li>
      ))}
    </ul>
  );
};
